import React from 'react';
import dynamic from 'next/dynamic';
import EnquiryHeroSection from "@/components/EnquiryContainer/EnquiryHeroSection";
import FloatingDirectBookingCTA from '@/components/CommonComponent/FloatingDirectBookingCTA';

const EnquiryCategorySelector = dynamic(() => import("@/components/EnquiryContainer/CategorySelector"));
const EnquiryTrustSection = dynamic(() => import("@/components/EnquiryContainer/TrustSection"));
const EnquiryTestimonialsSection = dynamic(() => import("@/components/EnquiryContainer/TestimonialSection"));
const EnquiryBookingForm = dynamic(() => import("@/components/EnquiryContainer/BookingForm"));
const EnquiryFAQSection = dynamic(() => import("@/components/EnquiryContainer/FAQSection"));
const EnquiryFinalCTA = dynamic(() => import("@/components/EnquiryContainer/FinalCTA"));
const VideoTestimonialsSection = dynamic(() => import("@/components/EnquiryContainer/VideoTestimonials"));

const EnquiryHomePage = ({ heroProps, enquiryData , languageSlug, hideCategorySelector = false }) => {
    // Defensive check to prevent crashes if data is missing
    const data = enquiryData || {};

    return (
        <div className="min-h-screen bg-white">
            <FloatingDirectBookingCTA />
            <EnquiryHeroSection {...heroProps} />
            {!hideCategorySelector && <EnquiryCategorySelector data={data.categories} />}
            <EnquiryTrustSection data={data.trust} />
            <VideoTestimonialsSection data={data.videoTestimonials} />
            <EnquiryTestimonialsSection data={data.testimonials} />
            <EnquiryBookingForm data={data.booking} languageSlug={languageSlug} />
            <EnquiryFAQSection data={data.faq} />
            <EnquiryFinalCTA data={data.cta} />
        </div>
    );
};

export default EnquiryHomePage;